import { useLayoutEffect, useRef, useState } from "react";

type UseTextOverflowTooltipOptions = {
  dependency: unknown;
};

const useTextOverflowTooltip = ({
  dependency,
}: UseTextOverflowTooltipOptions) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [tooltipMaxWidth, setTooltipMaxWidth] = useState("0px");

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) {
      return;
    }

    const isHorizontallyOverflowing = el.scrollWidth > el.clientWidth;
    const isVerticallyOverflowing = el.scrollHeight > el.clientHeight;
    setIsOverflowing(isHorizontallyOverflowing || isVerticallyOverflowing);

    const computedStyle = window.getComputedStyle(el);
    const horizontalPadding =
      parseFloat(computedStyle.paddingLeft) +
      parseFloat(computedStyle.paddingRight);
    const contentWidth = Math.max(el.clientWidth - horizontalPadding, 0);
    setTooltipMaxWidth(`${contentWidth}px`);
  }, [dependency]); 

  return {
    isOverflowing,
    textRef,
    tooltipMaxWidth,
  };
};

export default useTextOverflowTooltip;
